export default "__VITE_ASSET__B6ZEbSD5__"